import React, { useEffect, useState, useRef } from 'react'
const { domainForIframe } = process.env;


export default function Iframe({ match }) {
  const iframeRef = useRef();
  const [redirectUrl] = useState(decodeURIComponent(match.params.url));

  useEffect(() => {
    if (redirectUrl) {
      iframeRef.current.addEventListener('load', () => {
        console.log('load');
        window.postMessage({ eventName: 'load success',}, '*');
      })
    }
  }, [redirectUrl]);

  useEffect(() => {
    window.addEventListener('message', (event) => {
      // 接收iframe中传递的消息，并传递给主域下的其他窗口
      if (event.origin === domainForIframe) {
        const data = event.data || {};
        if (data.eventName === 'updateDocumentTitle') {
          document.title = data.title || document.title;
          return;
        }
        window.localStorage.setItem('iframe-msg', JSON.stringify({
          ...event.data,
          timestamp: new Date().getTime()
        }));
      }
    })
  }, [])
  return redirectUrl ? <iframe style={{ border: 'none' }} src={domainForIframe + redirectUrl} width='100%' height='100%' frameBorder="0" ref={iframeRef} /> : null;
}